import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';

class EditClass extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			clsname : '',
			desc : '',
			code : '',
			attper : '',
			atttype : '',
			days : '',
			syllname : '',
			_message : '',
			value : '',
			alertClass :'',
			isHidden : true
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.back = this.back.bind(this);
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** submit form **/
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		if(this.state.clsname && this.state.days && this.state.syllname){
			
			PostData('classs/update',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Class Updated Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("subform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getdetails();
	}
	
	/** get Class **/
	getdetails(){
		$("#showLoader").show();
		GetData('classs/getclassbyid/'+this.props.match.params.id).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					clsname : res[0]['class'],
					desc : res[0]['description'],
					code : res[0]['code'],
					attper : res[0]['attendanceper'],
					atttype: res[0]['type'],
					days: res[0]['workdays'],
					syllname: res[0]['syllabus']
				});
			}
		});
	}
	
	/** redirect to Class **/
	back(e){
		
		this.setState({_redirect :true});
	}
	
  render() {
	  
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/academic/class' />);
	}
	
	this.attype = [
		{value : '', name : 'Select'},
		{value : 'Daily', name : 'Daily'},
		{value : 'Subject Wise', name : 'Subject Wise'}
	];
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="12">
				<Card>
				  <form action="" method="post" role="form" id="subform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Edit Class</strong>
						<span className="pull-right">
							<Button outline color="primary" onClick={this.back}>Back</Button>
						</span>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Class Name <span className="text-danger">*</span></Label>
							  <Input type="text" name="clsname" required onChange={this.onChange} value={this.state.clsname} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Description</Label>
							  <Input type="textarea" name="desc" rows="2" onChange={this.onChange} placeholder="Description..." value={this.state.desc}/>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Code</Label>
							  <Input type="text" name="code" onChange={this.onChange} value={this.state.code}/>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Minimum Attendance Percentage</Label>
							  <Input type="text" name="attper" onChange={this.onChange} value={this.state.attper}/>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Attendance Type</Label>
							  <select name="atttype" onChange={this.onChange} className="form-control" value={this.state.atttype}>
								{this.attype.map((e,key)=>{
									return <option key={key} value={e.value}>{e.name}</option>
								})}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Total Working Days <span className="text-danger">*</span></Label>
							  <Input type="text" name="days" required onChange={this.onChange} value={this.state.days}/>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Syllabus Name <span className="text-danger">*</span></Label>
							  <Input type="text" name="syllname" required onChange={this.onChange} value={this.state.syllname}/>
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			</Row>
		</div>
	);
  }
}

export default EditClass;



// WEBPACK FOOTER //
// ./src/academic/Class/EditClass.js